import axios from "axios";
import { UpdateTransferId } from "./types";

export const updateTransferIdDetails = async (props: UpdateTransferId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/transferId/update`,
      {
        transferid_number: props.number,
        action: props.action,
        status: props.status,
        transferid_modifiedby: props.modifiedBy,
        transferid_name: props.name,
        transferid_description: props.description,
        deliverables: props.deliverables,
      },
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response.data;
  } catch (e) {
    return null;
  }
};
